<template>
  <tr class="std_list" style="text-align: center;">
    <td>{{student.name}}</td>
    <td v-for="result in results" :key="result.aId">
        <span v-if="result.type === 'string'">{{result.aRes}}</span>
        <span v-if="result.type === 'icon'"><span class="material-icons">{{result.aRes}}</span></span>
    </td>
    <td v-if="activities.length === 0">-</td>
  </tr>
</template>
<script>
export default {
  props: {
    student: Object,
    activities: Array
  },
  data () {
    return {
      // course_id: parseInt(this.$route.query.course),
      results: []
    }
  },
  methods: {
    get_results: function () {
      // this.$store.dispatch('request', {
      //   route: 'courses/' + this.course_id + '/members/' + this.student.id + '/result/'
      // }).then(r => {
      //   console.log(r)
      //   this.activities.forEach(a => {
      //     let result = r.find(x => x.activity_id === a.id)
      //     if (a.type !== 'uReply') {
      //       this.results.push({
      //         aType: a.type,
      //         aId: result.activity_id,
      //         aRes: result.number_of_view > 0 ? 'done' : 'close',
      //         type: 'icon'
      //       })
      //     } else {
      //       this.results.push({
      //         aType: a.type,
      //         aId: result.activity_id,
      //         aRes: result.result === null ? 'not yet mark' : result.result,
      //         type: 'string'
      //       })
      //     }
      //   })
      // })
    }
  },
  mounted () {
    // console.log(this.activities)
    this.activities.forEach((value) => {
      // console.log(value.id)
      let sorted = this.student.result.find(x => x.activity.id === value.id)
      // console.log(sorted)
      if (value.type !== 'uReply') {
        this.results.push({
          aType: value.type,
          aId: value.id,
          aRes: sorted.is_viewed === true ? 'done' : 'close',
          type: 'icon'
        })
      } else {
        this.results.push({
          aType: value.type,
          aId: value.id,
          aRes: sorted.isNullResult === true ? 'not yet mark' : sorted.result,
          type: 'string'
        })
      }
    })
  }
}
</script>
